// assets
import { IconUsers  } from '@tabler/icons';


// constant
const icons = {
    IconUsers 
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const subAgents = {
    id: 'subAgents',
    type: 'group',
    children: [
        {
            id: 'subAgents',
            title: 'Sub Agents',
            type: 'item',
            icon: icons.IconUsers ,
            url: '/member-management/subAccounts',

            // children: [
            //     {
            //         id: 'subAccounts',
            //         title: 'Sub Accounts',
            //         type: 'item',
            //         url: '/member-management/subAccounts',
            //         breadcrumbs: true
            //     }
            // ]
        }
    ]
};

export default subAgents;
